import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { EmailTemplate } from "../../bpe/bpe.service";
import { ModalComponent } from "../modal.component";

@Component({
    template: `
        @if (isInit) {
            <div class="s25-ng">
                <s25-modal-header [data]="data"></s25-modal-header>
                <div class="modal-body">
                    @if (data.title === "Preview Template") {
                        <div class="c-margin-bottom--single">Note: Pre variables display current data on preview.</div>
                    }
                    @if (!data.isToDoTemplate) {
                        <div>
                            <s25-ng-email-template-preview
                                [name]="data.name"
                                [code]="data.code"
                                [scenarioName]="data.scenarioName"
                                [reference]="data.reference"
                            ></s25-ng-email-template-preview>
                        </div>
                    }
                    @if (data.isToDoTemplate) {
                        <div>
                            <s25-ng-todo-email-template-preview
                                [name]="data.name"
                                [code]="data.code"
                                [scenarioName]="data.scenarioName"
                                [reference]="data.reference"
                            ></s25-ng-todo-email-template-preview>
                        </div>
                    }
                </div>
            </div>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ModalEmailTemplatePreviewComponent
    extends ModalComponent<{
        name: EmailTemplate["itemName"];
        code: any;
        scenarioName?: string;
        reference: string;
        isToDoTemplate: EmailTemplate["isToDoTemplate"];
    }>
    implements OnInit
{
    isInit = false;

    ngOnInit() {
        this.data.isToDoTemplate ? (this.data.title = "Preview To Do") : "";
        this.isInit = true;
    }
}
